import { useContext, useState, useEffect } from 'react';
import {
  Box,
  MenuItem,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Autocomplete,
  TextField
} from '@mui/material';

import { AuthContext, stopPropagationForTab } from 'components';
import { Tracking } from 'components/Tracking';
import { useNavigate } from "react-router-dom";


export const BulkModal = (props) => {
  const { items, onClose } = props;
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [ saving, setSaving ] = useState(false);
  const [value, setValue] = useState([]);
  const [categories, setCategories] = useState([]);
  const { customCategories, updateItem } = useContext(AuthContext);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    navigate("/products_reload");
    onClose();
  }

  const handleSave = () => {
    Tracking.track('Portal - Bulk edit Category', { items: items.length })
    let bulk_update = []

    items.forEach((item) => {
      bulk_update.push(new Promise((resolve, rejejct) => {
        updateItem(
          item,
          { 
            categoryId: value.id,
            categoryType: parseInt(value.category_group_id)
          },
          resolve
        )
      }))
    })

    Promise.all(bulk_update).then(() => {
      handleClose()
    })
  }

  useEffect(() => {

    let visibleEditCategories = Object.keys(customCategories).map((c) => ({
    ...customCategories[c],
    id: c
  })).sort((a, b) => {
    if (a.category_group_id != b.category_group_id) {
      return a.category_group_id - b.category_group_id
    }
    return a.sorting?.indexOf(a.id) > b.sorting?.indexOf(b.id) ? 1 : -1
  })
    setCategories(visibleEditCategories)
  }, [customCategories])
  
  return (
    <>
      <MenuItem onClick={handleOpen}>
        <div>Category</div>
      </MenuItem>
      <Dialog onKeyDown={stopPropagationForTab} open={open} onClose={handleClose}>
        <DialogTitle>Set Category</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Change category of all of your selected items
          </DialogContentText>
          <Autocomplete
            value={value}
            onChange={(event, value) => { setValue(value) }}
            options={categories}
            getOptionLabel={(option) => option.category || customCategories[option]?.category || "" }
            groupBy={(option) => option.category_group}
            renderOption={(props, option, state, ownerState) => {
              const { key, ...optionProps } = props;
              return (
                <Box
                  key={option.id}
                  component="li"
                  {...optionProps}
                >
                  {ownerState.getOptionLabel(option)}
                </Box>
              );
            }}
            renderInput={(params) => <TextField {...params} label="" />}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={saving} onClick={() => { setSaving(true); setTimeout(handleSave, 200) }}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}